import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-campana-admin-stats',
  templateUrl: './campana-admin-stats.component.html',
  styleUrls: ['./campana-admin-stats.component.scss']
})
export class CampanaAdminStatsComponent {

  @Input() estados: any[] = [];

}
